import { DECIMAL_ZERO, computedDecimalText } from "../values/decimal";

export type OrderTotalRow = { orderId: number; total: string | number };

function totalsById(rows: readonly OrderTotalRow[]): Map<number, string> {
  return new Map(rows.map((row) => [row.orderId, computedDecimalText(row.total)]));
}

export function attachPaidTotals<T extends { id: number }>(orders: readonly T[], rows: readonly OrderTotalRow[]) {
  const paid = totalsById(rows);
  return orders.map((order) => ({ ...order, paidTotal: paid.get(order.id) ?? DECIMAL_ZERO }));
}

export function attachMovedQuantities<T extends { id: number }>(orders: readonly T[], rows: readonly OrderTotalRow[]) {
  const moved = totalsById(rows);
  return orders.map((order) => ({ ...order, movedQuantity: moved.get(order.id) ?? DECIMAL_ZERO }));
}
